module.exports = __webpack_public_path__ + "img/pdf-logo.3a0b9195.png";